import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['context', 'trigger'];

  connect() {
    if (!this.hasContextTarget) {
      return;
    }

    this.setupTransition();
    this.hideContext();
    this.checkTriggers();
  }

  setupTransition() {
    if (!this.hasContextTarget) {
      return;
    }

    this.contextTarget.style.transition = 'opacity 0.3s ease-in-out';
    this.contextTarget.style.opacity = '0';
  }

  checkTriggers() {
    if (!this.hasContextTarget) {
      return;
    }

    const hasValue = this.triggerTargets.some((trigger) => {
      if (trigger.type === 'radio' || trigger.type === 'checkbox') {
        return trigger.checked;
      }
      return trigger.value.trim() !== '';
    });

    if (hasValue) {
      this.showContext();
    } else {
      this.hideContext();
    }
  }

  showContext() {
    if (!this.hasContextTarget) {
      return;
    }

    const context = this.contextTarget;

    context.classList.remove('d-none');

    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        context.style.opacity = '1';
      });
    });
  }

  hideContext() {
    if (!this.hasContextTarget) {
      return;
    }

    const context = this.contextTarget;

    context.style.opacity = '0';

    setTimeout(() => {
      if (context.style.opacity === '0') {
        context.classList.add('d-none');
      }
    }, 300);
  }
}
